import React from 'react'
import styled from 'styled-components'

import { FormGroup } from '../common/FormGroup'
import { FormLabel } from '../common/FormLabel'
import { FormError } from '../common/FormError'

export const FieldWrapper = ({
  upper,
  ghostLabel,
  meta = {}, label, children, className, disabled, required,
}) => (
  <FormGroup className={className}>
    {label && (
      <FormLabel
        upper={upper}
        tradId={label}
        required={required}
        disabled={disabled}
      />
    )}
    {ghostLabel && !label && (
      <GhostLabel>
        {/* Not so fond of it, but only way I found to have the right spacing adjusting with the font-size */}
        _
      </GhostLabel>
    )}
    <div>
      {children}
    </div>
    <FormError error={meta.touched && (meta.error || (!meta.dirtySinceLastSubmit && meta.submitError))} />
  </FormGroup>
)

const GhostLabel = styled(FormLabel)`
  visibility: hidden;
`
